import { api } from "./api";

// Query-Funktion fuer das Rollenmodell-Katalog. Der axios-timeout sorgt dafuer,
// dass ein im Browser haengender Request nach 8s rejectet, damit react-query
// automatisch erneut versucht. react-query uebernimmt Dedupe/Cache/Retry und ist
// robust gegen React-18-StrictMode-Doppel-Mounts.
export const catalogQuery = () =>
  api.get("/rollenmodell/catalog", { timeout: 8000 }).then((r) => r.data);
